require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./keyword-real-time-communication.json") })
        }
      }, "path---keyword-real-time-communication");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---keyword-real-time-communication!./.cache/json/keyword-real-time-communication.json
// module id = 725
// module chunks = 231608221292675